import React from "react";
import PropTypes from "prop-types";

// styles
import LoaderWrapper from "./Loader.styled";

const Loader = ({ local = false, blank = false }) => {
  return (
    <LoaderWrapper $local={local} $blank={blank} role="alert" aria-live="assertive">
      <div className="loader" aria-label="Loading.. please wait" role="img">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    </LoaderWrapper>
    );
};

export default Loader;
Loader.propTypes = {
    /**
	 * if local is true then the loader will stay within its parent component,
     * if it is not passed in then then loader fills up the whole screen
	 *  */
	local: PropTypes.bool,
    /**
     * if blank is true, no overlay background is shown
     */
	blank: PropTypes.bool
};